import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import DeltaArrowUp from './icon-delta-arrow-up.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <DeltaArrowUp {...validProps} />;
}
SvgComponent.iconName = 'deltaArrowUp';

/**
 * @deprecated This is a legacy icon
 */
export const DeltaArrowUpIcon = svgIconWrapper(SvgComponent);
